import React from 'react';
import {Link, NavLink} from 'react-router-dom';
import {withRouter} from '../../core/withRouter';
import {NewTabLink, HeaderSubBar} from 'fn-common-ui';
import {observer} from 'mobx-react';
import config from 'config';
import $ from 'jquery';

@withRouter
@observer
export default class Header extends React.Component {

  static propTypes = {
    store: require('prop-types').object.isRequired,
    location: require('prop-types').object
  };

  constructor(props) {
    super(props);
    this.headerStore = this.props.store.headerStore;
    this.userStore = this.props.store.userStore;
    this.joyrideStore = this.props.store.joyrideStore;
  }

  componentDidMount() {
    $('.dropdown-toggle').focus(() => {
      $('.dropdown.show').removeClass('show');
      $('.dropdown-menu.show').removeClass('show');
    });

    $('.dropdown-menu li:last-child a').keydown((e) => {
      // if user uses keyboard navigation, need to make sure we arent closing menu when user Shift+Tabs(goes to previous item)
      if (e.which == 9 && e.shiftKey) {
        // do nothing
      } else if (e.which == 9) {
        $('.dropdown.show').removeClass('show');
        $('.dropdown-menu.show').removeClass('show');
      }
    });
  }

  toggleProfileSubMenu = () => {
    this.headerStore.toggleProfileSubMenu();
  };

  toggleHelpSubMenu = () => {
    this.headerStore.toggleHelpSubMenu();
  };

  handleExternalTabOpen = () => {
    this.headerStore.externalTabOpen();
    this.toggleContentScrolling();
  }

  onLogout = event => {
    event.preventDefault();
    this.userStore.logoutUser();
  };

  toggleContentScrolling() {
    if (this.headerStore.mainMenuIsOpen) {
      $('body:not(.fnnav__main)').css('overflow', 'hidden');
      $('body:not(.fnnav__main)').css('position', 'fixed');
      $('body').css('width', '100%');
    } else {
      $('body').css('overflow', 'auto');
      $('body').css('position', 'relative');
      $('body').css('width', 'auto');
    }
  }

  handleToggleWalkthrough = () => {
    this.joyrideStore.toggleTour();
  }

  renderBrandArea = () => {
    return (<div className="fnnav__header">
      <div className="fnnav__brand">
        <Link className="logo-home-link logo-container" to="/">
          <img className="fnnav__brand__mobile" src="/images/firstnet-logo-white.svg" alt="FirstNet Built with AT&T"/>
          <span className="sr-only">Go Home</span>
        </Link>
      </div>
    </div>)
  }

  renderHelpMenuItems = () => {
    return [
      (<li key="li-faq">
        <NavLink activeClassName="active" to="/faq">
          FAQ
        </NavLink>
      </li>),
      (<li key="li-training">
        <NewTabLink
          to={config.firstnetTraining}
          onClick={this.handleExternalTabOpen}>
          <span className="pull-right-of-icon">Quick Help & Tutorials</span>
        </NewTabLink>
      </li>),
      (<li key="li-walkthru">
        <a href="#" role="button" className="walkthru-toggle" onClick={this.handleToggleWalkthrough}>
          {
            `${this.joyrideStore.tourIsDisabled
              ? 'Enable'
              : 'Disable'} Site Walkthrough`
          }
        </a>
      </li>),
      (<li key="li-help">
        <NewTabLink to={config.devCertificationAccrediation}>
          <span className="pull-right-of-icon">
            FirstNet App Review<br/>
            Process Help
          </span>
        </NewTabLink>
      </li>)
    ];
  }


  render() {
    return (<React.Fragment>
      <header className="fnnav pse" role="banner">
        <div className="fnnav__mainbar">
          <div className="container">
            {this.renderBrandArea()}
            <nav id="main-menu" aria-label="Main Menu">
              <ul className="fnnav__main walkthrough-navigation-menu">
                {/* Desktop only icon items */}
                <li className="desktop-iconItem dropdown">
                  <button id="profile-header-dropdown" type="button" className="dropdown-toggle" aria-expanded="false" data-toggle="dropdown" data-display="static">
                    <i className="icon-profile white" aria-hidden="true" />
                    <span className="sr-only">Toggle Profile Dropdown</span>
                  </button>
                  <ul id="profile-nav" className="dropdown-menu dropdown-menu-right" aria-labelledby="profile-header-dropdown">
                    <li role="presentation">
                      <NewTabLink to={config.manageAccount}>
                        Manage My Account
                      </NewTabLink>
                    </li>
                    <li role="presentation">
                      <NewTabLink to={config.changePassword}>
                        Change Password
                      </NewTabLink>
                    </li>
                    <li role="presentation">
                      <a href="#" onClick={this.onLogout}>
                        <i className="icon-log-out white" aria-hidden="true" />
                        <span className="pull-right-of-icon">Log Out</span>
                      </a>
                    </li>
                  </ul>
                </li>
                <li className="desktop-iconItem dropdown">
                  <button id="help-header-dropdown" aria-expanded="false" data-toggle="dropdown" data-display="static" type="button" className={`dropdown-toggle ${ (this.props.location.pathname === '/faq')
                      ? 'active'
                      : ''}`}>
                    <i className="icon-help white" aria-hidden="true" />
                    <span className="sr-only">Toggle Help Dropdown</span>
                  </button>
                  <ul id="help-nav" className="dropdown-menu dropdown-menu-right" aria-labelledby="help-header-dropdown">
                    {this.renderHelpMenuItems()}
                  </ul>
                </li>
              </ul>
            </nav>
          </div>
        </div>
        <HeaderSubBar logoSrc="/images/app-control-name-logo.svg" logoAlt="FirstNet App Control logo">
          <li id="hdr-myapps" className="mainnav-item desktop-textlink" role="presentation">
            <NavLink id="linkBtn-myApps" to="/my-apps" activeClassName="active" isActive={this.currentRouteOrHome}>
              My Apps
            </NavLink>
          </li>
          <li id="hdr-resources" className="mainnav-item desktop-textlink" role="presentation">
            <NewTabLink to={config.resourceCatalog}>
              Resources
            </NewTabLink>
          </li>
        </HeaderSubBar>
      </header>
    </React.Fragment>);
  }
}
